import { useEffect, useState } from "react";
import { Menu, X } from "lucide-react";
import { IMAGES, NAV_LINKS } from "../data/content";

export const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <>
      <header
        data-testid="nav-header"
        className={`fixed inset-x-0 top-0 z-50 transition-[background-color,border-color,backdrop-filter] duration-500 ${
          scrolled ? "bg-ink/90 backdrop-blur-md border-b hairline" : "bg-transparent border-b border-transparent"
        }`}
      >
        <div className="mx-auto flex max-w-7xl items-center justify-between px-5 py-4 sm:px-8">
          <a href="#ballina" data-testid="nav-logo" className="flex items-center gap-3">
            <img src={IMAGES.logo} alt="ALBESI AXH METAL" className="h-11 w-11 rounded-full object-cover ring-1 ring-white/15" />
            <span className="font-display text-sm font-bold tracking-[0.22em] text-white sm:text-base">
              ALBESI <span className="text-bronze">AXH</span> METAL
            </span>
          </a>

          <nav className="hidden items-center gap-8 lg:flex" data-testid="nav-links">
            {NAV_LINKS.map((l) => (
              <a
                key={l.href}
                href={l.href}
                data-testid={`nav-link-${l.href.slice(1)}`}
                className="text-sm font-medium text-white/70 transition-colors duration-300 hover:text-bronze"
              >
                {l.label}
              </a>
            ))}
            <a
              href="#kontakt"
              data-testid="nav-cta-offer"
              className="border border-bronze bg-bronze px-5 py-2.5 font-display text-xs font-semibold uppercase tracking-[0.18em] text-ink transition-colors duration-300 hover:bg-transparent hover:text-bronze"
            >
              Kërko ofertë
            </a>
          </nav>

          <button
            data-testid="nav-mobile-toggle"
            onClick={() => setOpen(true)}
            className="text-white lg:hidden"
            aria-label="Hap menynë"
          >
            <Menu size={26} />
          </button>
        </div>
      </header>

      {open && (
        <div data-testid="nav-mobile-menu" className="fixed inset-0 z-[60] flex flex-col bg-ink texture-grain">
          <div className="flex items-center justify-between px-5 py-4">
            <span className="font-display text-sm font-bold tracking-[0.22em] text-white">
              ALBESI <span className="text-bronze">AXH</span> METAL
            </span>
            <button data-testid="nav-mobile-close" onClick={() => setOpen(false)} className="text-white" aria-label="Mbyll menynë">
              <X size={28} />
            </button>
          </div>
          <nav className="flex flex-1 flex-col items-start justify-center gap-2 px-8">
            {NAV_LINKS.map((l, i) => (
              <a
                key={l.href}
                href={l.href}
                data-testid={`nav-mobile-link-${l.href.slice(1)}`}
                onClick={() => setOpen(false)}
                className="font-display text-4xl font-bold text-white/85 transition-colors duration-300 hover:text-bronze"
              >
                <span className="mr-4 text-sm font-medium text-bronze">0{i + 1}</span>
                {l.label}
              </a>
            ))}
            <a
              href="#kontakt"
              data-testid="nav-mobile-cta"
              onClick={() => setOpen(false)}
              className="mt-8 border border-bronze bg-bronze px-8 py-3.5 font-display text-sm font-semibold uppercase tracking-[0.18em] text-ink"
            >
              Kërko ofertë
            </a>
          </nav>
        </div>
      )}
    </>
  );
};
